import * as React from 'react';
import * as styles from './BannerLayout.css';

export const BannerLayout = React.forwardRef<HTMLDivElement, React.PropsWithChildren>(({ children }, ref) => {
  return (
    <div className={styles['banner-layout']} ref={ref}>
      {children}
    </div>
  );
});

BannerLayout.displayName = 'BannerLayout';
